// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'team';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.34 10.816a1.318 1.318 0 1 0 0-2.636 1.318 1.318 0 0 0 0 2.636zm2.152 1.644a2.719 2.719 0 0 0-4.3 0M3.66 10.816a1.318 1.318 0 1 0 0-2.636 1.318 1.318 0 0 0 0 2.636zM1.507 12.46a2.72 2.72 0 0 1 4.298-.006' />
    <path d='M12.36 13.5a3.36 3.36 0 0 0-6.72 0m3.325-4.278a1.986 1.986 0 1 0 0-3.972 1.986 1.986 0 0 0 0 3.972z' />
    <path d='M9 17.438A8.438 8.438 0 1 0 9 .561a8.438 8.438 0 0 0 0 16.875z' />
  </g>
);

export const viewBox = '0 0 18 18';
